<template>
  <!-- 上传打款凭证 -->
  <el-card shadow="never" class="invoice_card" style="min-height: 500px">
    <div slot="header" class="clearfix">
      <el-button type="text" class="backBtn" @click="changeBack">返回</el-button>
      <span class="font16">上传打款凭证</span>
    </div>
    <el-form ref="form" :model="form" :rules="rules" style="padding:5px 10px" label-width="150px">
      <el-form-item label="打款金额:" prop="accountingInformation">¥{{form.invoiceAmount}}</el-form-item>
      <el-form-item label="上传打款凭证:" prop="uploadPaymentVoucherList" ref="file">
        <uploadText
          :fileList="form.uploadPaymentVoucherList"
          ref="getfile"
          :limit="10"
          @getFile="getFile"
          @clearValidate="clearValidate"
        ></uploadText>
        <span class="formTips">最多上传10份文件</span>
      </el-form-item>
    </el-form>
    <el-dialog
      title="凭证上传成功"
      :visible.sync="dialogVisible"
      width="500px"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
      :before-close="handleClose">
      <div style="padding: 20px 50px;">
        <div>请您耐心等待，我们会在1-3个工作日内进行核销</div>
        <div>如需加急处理，请联系客服~</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeBack">确 定</el-button>
      </span>
    </el-dialog>
    <div style="text-align: center;margin-top: 20px">
      <el-button @click="handleSubmit()" type="primary" v-preventClick>确认上传</el-button>
    </div>
  </el-card>
</template>

<script>
import { uploadPaymentVoucher } from "@/api/request";
import uploadText from "../../common/uploadText";
export default {
  components: {
    uploadText
  },
  data() {
    return {
      rules: {
        uploadPaymentVoucherList: [
          { required: true, message: "请上传打款凭证", trigger: "change" }
        ]
      },
      dialogVisible: false,
      form: {
        invoiceId: null,  
        invoiceAmount: 0.0,
        uploadPaymentVoucherList: []
      }
    };
  },
  methods: {
    init(row) {
      this.form.invoiceId = row.invoiceId  
      this.form.invoiceAmount = row.invoiceAmount;
      this.form.uploadPaymentVoucherList = [];
      this.$nextTick(() => {});
    },
    changeBack() {
      this.dialogVisible = false
      document.documentElement.scrollTop = 0;
      this.$emit("back");
    },
    getFile(file) {
      this.form.uploadPaymentVoucherList = file;
    },
    clearValidate() {
      this.$refs.file.clearValidate();
    },
    handleSubmit() {
      this.$refs.getfile.getFile();
      if (this.form.uploadPaymentVoucherList.length > 0) {
        this.$refs.file.clearValidate();
      }
      this.$refs["form"].validate(valid => {
        if (valid) {
          uploadPaymentVoucher(this.form).then(res => {
            // this.$message.success("上传成功");
            // this.changeBack();
            this.dialogVisible = true
            
          });
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>
